import domReady from '@wordpress/dom-ready';
/**
 * Hero block – animated placeholder typewriter effect
 */

domReady(() => {
  const input = document.querySelector('.hero__search-field');
  if (!input) return;

  // Prefer ACF-managed phrases; fall back to the static placeholder
  let phrases;
  const dataAttr = input.getAttribute('data-placeholders');
  if (dataAttr) {
    try {
      phrases = JSON.parse(dataAttr).filter(Boolean);
    } catch (e) {
      phrases = [];
    }
  }
  if (!phrases || phrases.length < 2) {
    phrases = [input.getAttribute('placeholder')].filter(Boolean);
  }

  if (phrases.length < 2) return;

  const TYPING_SPEED = 55; // ms per character (typing)
  const DELETING_SPEED = 30; // ms per character (deleting)
  const PAUSE_AFTER = 2200; // ms to wait after full phrase is typed

  let phraseIndex = 0;
  let charIndex = 0;
  let isDeleting = false;
  let isPaused = false;
  let timeoutId = null;

  function tick() {
    if (isPaused) return;

    const current = phrases[phraseIndex];

    if (isDeleting) {
      charIndex--;
    } else {
      charIndex++;
    }

    input.setAttribute('placeholder', current.slice(0, charIndex));

    let delay = isDeleting ? DELETING_SPEED : TYPING_SPEED;

    if (!isDeleting && charIndex === current.length) {
      // Full phrase typed — pause before deleting
      delay = PAUSE_AFTER;
      isDeleting = true;
    } else if (isDeleting && charIndex === 0) {
      // Phrase fully deleted — move to next
      isDeleting = false;
      phraseIndex = (phraseIndex + 1) % phrases.length;
      delay = TYPING_SPEED;
    }

    timeoutId = setTimeout(tick, delay);
  }

  // Pause while the user is typing
  input.addEventListener('focus', () => {
    isPaused = true;
    clearTimeout(timeoutId);
    // Restore placeholder opacity while focused (browser hides it anyway)
  });

  input.addEventListener('blur', () => {
    if (input.value === '') {
      isPaused = false;
      tick();
    }
  });

  // Kick off
  tick();
});
